import { HydrationBoundary, type DehydratedState } from '@tanstack/react-query'
import React from 'react'
import { CookieProvider } from './cookie.provider'

interface IDehydrationProps {
  dehydratedState: DehydratedState
  children: React.ReactNode
}

export const Dehydration = async (props: IDehydrationProps) => {
  const { dehydratedState, children } = props
  let token = {}
  if (typeof window === 'undefined') {
    const { cookies } = await import('next/headers')
    const cookieStore = await cookies()
    const accessToken = cookieStore?.get('access_token')?.value
    const refreshToken = cookieStore?.get('refresh_token')?.value
    token = {
      accessToken,
      refreshToken,
    }
  }

  return (
    <CookieProvider token={token}>
      <HydrationBoundary state={dehydratedState}>{children}</HydrationBoundary>
    </CookieProvider>
  )
}
